export default "__VITE_ASSET__f500c23d__"